import { BannerFormProvider } from "../../contexts/BannerFormContext";
import { UpdateBannerContent } from "./UpdateBannerContent";

type PropTypes = {
  onBack: () => void;
  selectedId: string;
};
export const UpdateBanner = ({ onBack, selectedId }: PropTypes) => {
  return (
    <BannerFormProvider>
      <UpdateBannerContent onBack={onBack} selectedId={selectedId} />
    </BannerFormProvider>
  );
};
